<mat-progress-bar
        *ngIf="dataExchangeService.loadingStatus >= 0 &&
        dataExchangeService.loadingStatus < 1"
        [value]="dataExchangeService.loadingStatus * 100"
        mode="determinate">
</mat-progress-bar>

<div class="main-flexbox">
    <!--selector for sex-->
    <div class="patient">
        <div [ngStyle]="containerService.patient?{width: '90%'}: {width: '100%'}">
            <mat-button-toggle-group class="toggle-group-sex">
                <mat-button-toggle #settings class="settings-sex" disabled>
                    {{'Sex' | translate}}:
                </mat-button-toggle>
                <mat-button-toggle (click)="sexChanged('male')" [checked]="isCheckedSex('male')"
                                   class="settings-sex-button">
                    {{'Male' | translate}}
                </mat-button-toggle>
                <mat-button-toggle (click)="sexChanged('female')" [checked]="isCheckedSex('female')"
                                   class="settings-sex-button">
                    {{'Female' | translate}}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div *ngIf="containerService.patient" class="info_btn">
            <button (click)="openPatientDialog()" aria-label="Example icon button with a delete icon" color="primary"
                    mat-fab>
                <mat-icon>perm_identity</mat-icon>
            </button>
        </div>
    </div>


    <!--selector for height-->
    <burncase-target-adaption [headerName]="'Height'" [inputMax]="230" [inputName]="'height'" [inputStep]="0.1"
                              [sliderId]="1"
                              [sliderMax]="230" [sliderStep]="0.1" [sliderValue]="178.8" [unitSlider]="'cm'"
                              style="align-self: stretch">
    </burncase-target-adaption>

    <!--selector for age-->
    <burncase-target-adaption (sliderResult)="weightAdjustment($event)" [headerName]="'Age'" [inputMax]="30"
                              [inputMin]="0.5" [inputStep]="0.25"
                              [sliderId]="2" [sliderMax]="30"
                              [sliderMin]="0.5" [sliderStep]="0.25" [sliderValue]="dataExchangeService.patient.age"
                              [unitSlider]="'yrs'"
                              style="align-self: stretch">
    </burncase-target-adaption>

    <!--selector for weight-->
    <burncase-target-adaption [headerName]="'BMI'" [inputMax]="1.2" [inputMin]="-0.8" [inputStep]="0.1"
                              [sliderId]="3" [sliderMax]="weightMax"
                              [sliderMin]="weightMin" [sliderStep]="0.1"
                              [sliderValue]="dataExchangeService.patient.convertedBMI" [unitSlider]="' '"
                              style="align-self: stretch">
    </burncase-target-adaption>

</div>


<!--<div style="margin-top: 5px;">-->
<!--    <button (click)="logout()" color="primary" mat-raised-button type="submit">Logout</button>-->
<!--</div>-->
